import { render, staticRenderFns } from "./SetLink.vue?vue&type=template&id=37b8e79e&scoped=true&"
import script from "./SetLink.vue?vue&type=script&lang=js&"
export * from "./SetLink.vue?vue&type=script&lang=js&"
import style0 from "./SetLink.vue?vue&type=style&index=0&id=37b8e79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8e79e",
  null
  
)

export default component.exports